<script>
// import DropDown from './reUse/DropDown.js';
import Notification from '../reUse/Notification.vue';
import {i18n} from '@/i18n'
import {config} from '@/config'
import sl from '@/Prevodi/ZapisRazpored-sl.json';
import en from '@/Prevodi/ZapisRazpored-en.json';
import it from '@/Prevodi/ZapisRazpored-it.json';

export default {
  components: {
    // DropDown,
    Notification,
  },
  props: {
    user: Object,
  },
  emits: [],
  data() {
    return {
      prevodi: false,
      datum: new Date().toISOString().split('T')[0],
      VsiZapisi: [],
      VseAktivnosti: [],
      VsiRazporedi: [],
      DnevniPlan: [],
      Aktivnosti: [],
      Razporedi: [],
      text: '',
      types: '',
      ShowNoti: false,
      isLoading: false,
      pot: config.baseUrl,
      tiskam: false,
      posiljam: false,
      dniPregleda: null,
    }
  },
  created() {
    this.loadTranslationsDirekt('sl', sl);
    this.loadTranslationsDirekt('en', en);
    this.loadTranslationsDirekt('it', it);
    this.prevodi = true;
  },
  mounted() {
    this.GetDnevniPlan();
    if (config.UserLVL === 2) {
      this.NastavitevPregleda();
    }

  },
  computed: {
    JadralniRazpored() {
      return this.Razporedi.filter(letalo => letalo.vrsta_letala === 'Jadralno');
    },
    MotorniRazpored() {
      return this.Razporedi.filter(letalo => letalo.vrsta_letala === 'Motorno');
    },
    UltraLightRazpored() {
      return this.Razporedi.filter(letalo => letalo.vrsta_letala === 'UltraLight');
    }
  },
  methods: {
    async NastavitevPregleda() {
      await axios.get('./api/nastavitve/pregled/').then((response) => {
        this.dniPregleda = response.data.dni;
      }).catch((error) => {
        //TODO
      });
    },
    NastaviDatum() {
      let datum = new Date();
      datum.setDate(datum.getDate() - this.dniPregleda);

      return datum.toISOString().split('T')[0];
    },
    GetDnevniPlan() {
      axios
          .get("./api/dnevniplan/izpis/")
          .then((response) => {
            this.VsiZapisi = response.data.dnevni_plan;
            this.VseAktivnosti = response.data.aktivnosti;
            this.VsiRazporedi = response.data.razporedi;
            this.CheckDate();
          })
          .catch((napaka) => {

          })
    },
    CheckDate() {
      const vsiZapisi = this.VsiZapisi;
      const vseAktivnosti = this.VseAktivnosti;
      const vsiRazporedi = this.VsiRazporedi;
      this.DnevniPlan = [];
      this.Aktivnosti = [];
      this.Razporedi = [];
      this.DnevniPlan = vsiZapisi.filter(zapis => {
        return new Date(zapis.datum).toISOString().split('T')[0] === this.datum;
      });

      this.Aktivnosti = vseAktivnosti.filter(aktivnosti => {
        return new Date(aktivnosti.datum).toISOString().split('T')[0] === this.datum;
      });

      this.Razporedi = vsiRazporedi.filter(razporedi => {
        return new Date(razporedi.datum).toISOString().split('T')[0] === this.datum;
      });
    },
    NatisniIzpise() {
      this.tiskam = true;
      var podatki = new URLSearchParams();
      var zapisi = [];
      zapisi.push({'aktivnosti': this.Aktivnosti});
      zapisi.push({'razporedi': this.Razporedi});
      podatki.append('podatki', JSON.stringify(zapisi));
      podatki.append('datum', this.datum);
      podatki.append('nalog', this.DnevniPlan[0].st_naloga);
      axios.post('./api/dnevniplan/pdf/', podatki, {withCredentials: true}).then((response) => {
        window.open(this.pot + response.data.datoteka);
        this.tiskam = false;
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          // this.text = 'Napaka pri pridobivanju podatkov. '+napaka.response.data.napaka;
          this.text = this.$t('obvestila.vnosNeuspesen');
        } else {
          // this.text = 'Napaka pri pridobivanju podatkov.';
          this.text = this.$t('obvestila.vnosNeuspesen');
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
        this.tiskam = false;
      });
    },
    SendToMail() {
      this.posiljam = true;
      this.isLoading = true;
      var podatki = new URLSearchParams();
      var zapisi = [];
      zapisi.push({'aktivnosti': this.Aktivnosti});
      zapisi.push({'razporedi': this.Razporedi});
      podatki.append('podatki', JSON.stringify(zapisi));
      podatki.append('datum', this.datum);
      podatki.append('nalog', this.DnevniPlan[0].st_naloga);
      axios.post('./api/dnevniplan/pdf/', podatki, {withCredentials: true}).then((response) => {
        var podatkiMail = new URLSearchParams();
        podatkiMail.append('datoteka', response.data.datoteka);
        podatkiMail.append('zadeva', 'Izpisek dnevnega plana');
        axios.post('./api/log/mail/', podatkiMail, {withCredentials: true}).then((response) => {
          // this.text = (response.data.sporocilo);
          this.text = this.$t('obvestila.poslano');
          this.types = "Uspešno";
          this.ShowNoti = true;
          this.isLoading = false;
          this.posiljam = false;
        }).catch((napaka) => {
          if (napaka.response.status === 401) {
            this.$router.push('/Logout');
          }
          if (napaka.response.data.napaka !== undefined) {
            // this.text = 'Napaka pri pošiljanju podatkov. '+napaka.response.data.napaka;
            this.text = this.$t('obvestila.niPoslano');
          } else {
            // this.text = 'Napaka pri pošiljanju podatkov.';
            this.text = this.$t('obvestila.nepricakovanaNapaka');
          }
          this.types = 'Napaka';
          this.ShowNoti = true;
          this.posiljam = false;
        });
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          // this.text = 'Napaka pri pridobivanju podatkov. '+napaka.response.data.napaka;
          this.text = this.$t('obvestila.vnosNeuspesen');
        } else {
          // this.text = 'Napaka pri pridobivanju podatkov.';
          this.text = this.$t('obvestila.nepricakovanaNapaka');
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
        this.posiljam = false;
      });
    },
    async loadTranslations(lang, path) {
      const response = await fetch(path);
      const json = await response.json();
      i18n.global.mergeLocaleMessage(lang, json);
      // this.$i18n.mergeLocaleMessage(lang, json);
    },
    loadTranslationsDirekt(lang, messages) {
      i18n.global.mergeLocaleMessage(lang, messages)
    },
  }
}
</script>
<template>
  <div class="container p-2" v-if="prevodi">
    <h5 v-if="user.lvl > 1" class="text-white text-center p-2">{{ $t('main.titleAktivnosti') }}</h5>
    <h5 v-else class="text-white text-center p-2">{{ $t('main.subtitleAktivnosti') }}</h5>
    <div v-if="user.lvl <= 1" class="col-12">
      <div class="container">
        <div class="label-date p-2 col-6" for="datum">{{ $t('labels.datum') }}</div>
        <input class="input border-0 rounded-4 p-2 fs-5" type="date" id="datum" v-model="datum" required
               @change="CheckDate()"/><br/><br/>
        <button class='btn btn-sm btn-outline-warning'
                :disabled="!Razporedi.length > 0 && !Aktivnosti.length > 0 || tiskam" @click.prevent="NatisniIzpise">
          Natisni <i class="fas fa-print" :class="{'fa-spin': tiskam}"></i></button>
        &nbsp;
        <button class='btn btn-sm btn-outline-warning'
                :disabled="!Razporedi.length > 0 && !Aktivnosti.length > 0 || posiljam" @click.prevent="SendToMail">
          Pošlji
          <i class="far fa-envelope"></i>
        </button>
        &nbsp;
        <div v-if="isLoading" class="spinner-border text-warning spinner-border-sm" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
    <div v-if="user.lvl >= 1 && dniPregleda > 0" class="col-12">
      <div class="container">
        <div class="label-date p-2 col-6">{{ $t('labels.datum') }}</div>
        <input class="input border-0 rounded-4 p-2 fs-5" type="date" id="datum" v-model="datum"
               v-if="this.dniPregleda !== null" :min="NastaviDatum()" required @change="CheckDate()"/>
      </div>
    </div>
    <div class="hr-with-text p-2" v-if="user.lvl <= 1">{{ $t('aktivnosti.title') }}</div>
    <div class="row g-3">
      <!-- Card -->
      <h4 class="text-center text-warning mb-4">
        <strong>{{ $t('aktivnosti.opozorila') }}</strong>
      </h4>
      <div class="col-12 col-md-6 col-lg-4" v-for="id in Aktivnosti" :key="id.id">
        <div class="card bg-cards text-white shadow h-100 hover-card">
          <div class="card-body text-center">
            <h5 class="card-title text-warning mb-3">{{ id.aktivnost }}</h5>
            <p class="mb-0 d-flex justify-content-between">
              <span><strong>{{ $t('aktivnosti.vnesel') }}</strong> {{ id.vnesel }}</span>
              <span> <strong>{{ $t('aktivnosti.cas') }}</strong> {{ id.cas }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container p-2" v-if="prevodi">
    <h4 class="text-center text-white mb-4">{{ $t('aktivnosti.mainTitle') }}</h4>
    <div class="row g-3" v-if="JadralniRazpored.length > 0">
      <h5 class='text-center text-white mb-4'>{{ $t('razpored.titleJ') }}</h5>
      <!-- Card Jadralno -->
      <div class="col-12 col-md-6 col-lg-4" v-for="(id, key) in JadralniRazpored" :key="id.id">
        <div class="card bg-cards text-white shadow h-100 hover-card">
          <div class="card-body">
            <h5 class="card-title text-center mb-3">{{ $t('razpored.let') }} #{{ key + 1 }}</h5>
            <p class='text-end triangle-current' v-if="!id.current && user.lvl <=2">
              <i class="fas fa-exclamation-triangle text-danger"></i>
            </p>

            <p class="mb-2">
              <strong class="text-left">{{ $t('razpored.planirano') }}</strong> {{ id.planirano }}
            </p>
            <p class="mb-2">
              <strong class="text-left">{{ $t('razpored.naloga') }}</strong> {{ id.naloga }} <i
                v-if="user.lvl <=2 && (id.naloga === 'Ruta' || id.naloga === 'Prelet')"
                class="fas fa-file-alt text-warning"></i>
            </p>
            <p class="mb-2">
              <strong class="text-left">{{ $t('razpored.sredstvo') }}</strong> {{ id.sredstvo }}
            </p>
            <p class="mb-2">
              <strong class="text-left">{{ $t('razpored.vrstaLetala') }}</strong> {{ id.vrsta_letala }}
            </p>
            <p class="mb-2">
              <strong class="text-left">{{ $t('razpored.izvrsilec') }}</strong> {{ id.izvrsilec }}
            </p>
            <p class="mb-0">
              <strong class="text-left">{{ $t('razpored.podpis') }}</strong> <img :src="id.podpis" alt="Podpis"
                                                                                  style="max-width: 100px;"/>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row g-3" v-if="MotorniRazpored.length > 0">
      <h5 class='text-center text-white mb-4 mt-5'>{{ $t('razpored.titleM') }}</h5>
      <!-- Card Motorno -->
      <div class="col-12 col-md-6 col-lg-4" v-for="(id, key) in MotorniRazpored" :key="id.id">
        <div class="card bg-cards text-white shadow h-100 hover-card">
          <div class="card-body">
            <h5 class="card-title text-center mb-3">{{ $t('razpored.let') }} #{{ key + 1 }}</h5>
            <p class='text-end triangle-current' v-if="!id.current && user.lvl <=2">
              <i class="fas fa-exclamation-triangle text-danger"></i>
            </p>

            <p class="mb-2">
              <strong class="text-left">{{ $t('razpored.planirano') }}</strong> {{ id.planirano }}
            </p>
            <p class="mb-2">
              <strong class="text-left">{{ $t('razpored.naloga') }}</strong> {{ id.naloga }}
              <i v-if="user.lvl <=2 && (id.naloga === 'Ruta' || id.naloga === 'Prelet')"
                 class="fas fa-file-alt text-warning"></i>
            </p>
            <p class="mb-2">
              <strong class="text-left">{{ $t('razpored.sredstvo') }}</strong> {{ id.sredstvo }}
              <i class="fas fa-balance-scale text-primary"></i>
            </p>
            <p class="mb-2">
              <strong class="text-left">{{ $t('razpored.vrstaLetala') }}</strong> {{ id.vrsta_letala }}
            </p>
            <p class="mb-2">
              <strong class="text-left">{{ $t('razpored.izvrsilec') }}</strong> {{ id.izvrsilec }}
            </p>
            <p class="mb-0">
              <strong class="text-left">{{ $t('razpored.podpis') }}</strong> <img :src="id.podpis" alt="Podpis"
                                                                                  style="max-width: 100px;"/>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row g-3" v-if="UltraLightRazpored.length > 0">
      <h5 class='text-center text-white mb-4 mt-5'>{{ $t('razpored.titleUL') }}</h5>
      <!-- Card Ultralight -->
      <div class="col-12 col-md-6 col-lg-4" v-for="(id, key) in UltraLightRazpored" :key="id.id">
        <div class="card bg-cards text-white shadow h-100 hover-card">
          <div class="card-body">
            <h5 class="card-title text-center mb-3">{{ $t('razpored.let') }} #{{ key + 1 }}</h5>
            <p class='text-end triangle-current' v-if="!id.current && user.lvl <=2">
              <i class="fas fa-exclamation-triangle text-danger"></i>
            </p>

            <p class="mb-2">
              <strong class="text-left">{{ $t('razpored.planirano') }}</strong> {{ id.planirano }}
            </p>
            <p class="mb-2">
              <strong class="text-left">{{ $t('razpored.naloga') }}</strong> {{ id.naloga }} <i
                v-if="user.lvl <= 2 && (id.naloga === 'Ruta' || id.naloga === 'Prelet')"
                class="fas fa-file-alt text-warning"></i>
            </p>
            <p class="mb-2">
              <strong class="text-left">{{ $t('razpored.sredstvo') }}</strong> {{ id.sredstvo }}
            </p>
            <p class="mb-2">
              <strong class="text-left">{{ $t('razpored.vrstaLetala') }}</strong> {{ id.vrsta_letala }}
            </p>
            <p class="mb-2">
              <strong class="text-left">{{ $t('razpored.izvrsilec') }}</strong> {{ id.izvrsilec }}
            </p>
            <p class="mb-0">
              <strong class="text-left">{{ $t('razpored.podpis') }}</strong> <img :src="id.podpis" alt="Podpis"
                                                                                  style="max-width: 100px;"/>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Transition name="fade">
    <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @closeNotification="ShowNoti = false"/>
  </Transition>
</template>